<template>
  <div class="jps-search-count jps-block" v-if="ss.state.result">
    <template v-if="ss.state.result.hit > 0"
      >{{ num(ss.state.result.hit) }}{{ lss('件', 'Records') }}</template
    >
    <template v-else>{{ lss('見つかりませんでした。', 'Not found') }}</template>
  </div>
</template>

<script lang="ts" setup>
const { num, lss } = useI18n()

interface Props {
  ss: SearchStore<any>
}
const props = withDefaults(defineProps<Props>(), {
})
</script>

<style lang="scss" scoped>
.jps-search-count {
  width: 100%;
  margin-top: 0.5rem;
  text-align: center;
  font-weight: bold;
}
</style>
